import { appLink } from '@experience/core-app-link-lib';
import { createI18n } from '@experience/i18n';
import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, createRouterMatcher } from 'vue-router';

import App from '@/app/App.ce.vue';
import { MF_NAME } from '@/app/const';
import { defaultRoutes } from '@/app/router';
import { createLogger } from '@/shared/utils/logger';

const matcher = createRouterMatcher(defaultRoutes, {});

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,

      configureApp(app) {
        const i18n = createI18n({
          legacy: false,
          locale: 'ru',
        });
        createLogger(import.meta.env.VITE_LOG_LEVEL ?? 'none');

        app.use(appLink({ matcher, hostAppRouterName: '__HOST_APP_ROUTER__' }));
        app.use(createPinia());
        app.use(createHead());
        app.use(i18n);

        const router = createRouter({
          history: createWebHistory('/journal'),
          routes: defaultRoutes,
          scrollBehavior(to) {
            if (to.hash) {
              return false;
            }
            return { top: 0, left: 0 };
          },
        });

        app.use(router);
      },
    }),
});
